import * as React from 'react';
import Grid from '@mui/material/Grid';
import { FormControl, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import SelectProvince from './Input/SelectProvince';
import SelectProvider from './Input/SelectProvider';

const useStyles = makeStyles(function (theme) {
  return {
    gridContainer: {
      [theme.breakpoints.up("sm")]: {
        paddingLeft: '100px',
        paddingRight: '100px'
      },
      [theme.breakpoints.up("md")]: {
        paddingLeft: '150px',
        paddingRight: '150px'
      },
      [theme.breakpoints.up("lg")]: {
        paddingLeft: '200px',
        paddingRight: '200px'
      },
      [theme.breakpoints.only("xl")]: {
        paddingLeft: ' 300px',
        paddingRight: '300px'
      },
    },
  };
});

const titleStyle = { textAlign: 'center' };
const textWidth = { maxWidth: '400px' };
const marginStyle = { mt: 2 };

export default function InputWater() {
  const classes = useStyles();

  return (
    <React.Fragment>
            <Typography variant="h3" gutterBottom sx={titleStyle}> Pay For Water </Typography>
      <Typography variant="h3" gutterBottom sx={titleStyle}> At more than 50 suppliers </Typography>
      <Grid container spacing={3} sx={marginStyle} justifyContent="center" alignItems="center" className={classes.gridContainer} >
        <Grid item xs={12} sx={titleStyle}>
          <SelectProvince  sx={titleStyle}/>
        </Grid>
        <Grid item xs={12} sx={titleStyle}>
        <SelectProvider  sx={titleStyle}/>
        </Grid>
        <Grid item xs={12} sx={titleStyle}>
        <FormControl sx={textWidth} fullWidth>
          <TextField
            fullWidth
            variant="outlined"
            label="Customer Code"
          />
        </FormControl>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}